import { Outlet, useMatches } from 'react-router-dom';
import { AppShell } from '@/layouts/AppShell';
import { ErrorState } from '@/components/ErrorState';
import { useGetCurrentUserQuery } from '@/services/api';

export function AccountShell(): JSX.Element {
  const userQ = useGetCurrentUserQuery();
  const matches = useMatches();

  if (userQ.isError) {
    return (
      <div className="content" style={{ paddingTop: 48 }}>
        <ErrorState
          title="Couldn't load your account"
          body="The account service is unreachable."
          onRetry={() => void userQ.refetch()}
        />
      </div>
    );
  }

  if (!userQ.data) {
    return <div className="content" style={{ paddingTop: 48 }} aria-busy="true" />;
  }

  const crumbs = matches
    .map((m) => (m.handle as { crumb?: string } | undefined)?.crumb)
    .filter((c): c is string => typeof c === 'string')
    .map((label) => ({ label }));

  return (
    <AppShell project={null} user={userQ.data} crumbs={crumbs}>
      <Outlet />
    </AppShell>
  );
}
